<template>
    <properties-block v-bind="$props" v-on="$listeners">
        <properties-component-glyph title="Glyph|Icône" :value="block.glyph" v-bind="componentProps"/>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import PropertiesComponentGlyph from "@components/editor/properties/components/properties-component-glyph.vue";

// properties-block-glyph #hot-reload-debug
export default {
    name: `properties-block-glyph`,
    components: {PropertiesComponentGlyph, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
